<script setup>
import { ref, computed } from "vue";
import { useGroupStore } from "@/stores/useGroupStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);
const store = useGroupStore();

const selectedCount = computed(() => store.selectedGroupIds.length);

// Congela a contagem porque a store pode limpar a seleção após deletar
const frozenCount = ref(selectedCount.value);
if (!frozenCount.value || frozenCount.value < 1) frozenCount.value = 1;

const modalTitle = "Apagar Grupos em Lote";

const messageTitle = computed(() => {
  const n = frozenCount.value;

  if (n <= 1) return "Você está prestes a apagar 1 grupo selecionado.";
  return `Você está prestes a apagar ${n} grupos selecionados.`;
});

const messageSubtitle = computed(() => "Esta ação não pode ser desfeita.");

const successMessage = computed(() => {
  const n = frozenCount.value;

  if (n <= 1) return "Grupo apagado com sucesso.";
  return `${n} grupos apagados com sucesso.`;
});

function buildErrorMessage(error) {
  return (
    error?.response?.data?.message ||
    error?.message ||
    "Ocorreu um erro ao excluir os grupos."
  );
}

async function onConfirmDelete() {
  try {
    await store.deleteSelectedGroups();

    store.selectedGroupIds = [];

    emit("notify", {
      type: "success",
      message: successMessage.value,
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildErrorMessage(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    :title="modalTitle"
    :messageTitle="messageTitle"
    :messageSubtitle="messageSubtitle"
    confirmText="Sim, apagar"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
